export class Constants {
    public static Default = 'Default';
    public static StrongRed = 'StrongRed';
    public static DarkRed = 'DarkRed';
    public static StrongRedFromDB = 'Strong Red';
    public static DarkRedFromDB = 'Dark Red';
    public static DarkGrey = 'DarkGrey';
    public static DarkGreyFromDB = 'Dark Grey';
    public static OhioUniversityFromDB = 'Ohio University';
    public static OhioUniversity = 'OhioUniversity';
    public static WrightStateUFromDB = 'Wright State';
    public static WrightState = 'WrightState';
    public static ClaymontSchoolsFromDB = 'Claymont Schools';
    public static ClaymontSchools = 'ClaymontSchools';
    public static Orgadmin = 'Organization Admin';
    public static Cliadmin = 'Clinic Admin';
    public static CommunityPartner = 'Community Partner';
    public static Patient = 'Patient';
    public static Clinician = 'Clinician';
    public static SocialWorker = 'Social Worker';
    public static ClinicWaitingRoomLevel = 'Clinic';
    public static ClinicianWaitingRoomLevel = 'Clinician';
    public static None = 'None';
    public static Hospital_org = 'Hospital';
    public static Opi_org = 'Critcal Response';
    public static Exists = 'exists';
    public static ExistsAppointment = 'exists appointment';
    public static ExistsWaitingRoom = 'exists waitingroom';
    public static Available = 'Available';
    public static sysadmin = 'System Admin';
    public static CheckedIn = 'checkedIn';
    public static Success = 'success';
    public static All = 'All';
    public static Other = 'Other';
    public static OtherSupport = 'Other Support Assistance';
    public static Radio = 'Radio';
    public static Check = 'Check';
    public static Closed = 'Closed';
    public static AgencyReferredTo = 'Agency referred to';
    public static CheckBoxQuestion = 'Check Boxes';
    public static RadioButtonType = 'Radio Buttons';
    public static TextAreaType = 'Text Area';
    public static Document = 'Document';
    public static Link = 'Link';
    public static pdfType = 'pdf';
    public static InternalDocType = 'Internal';
    public static Clinic = 'clinic';
    public static NorthAlleghenyFromDB = 'North Allegheny';
    public static NorthAllegheny = 'NorthAllegheny';
    // for CAA
    public static Participants = 'Participant';
    public static Client = 'Client';
    public static CaseManager = 'Case Manager';
    public static DropInCenter = 'drop-in center';
    // CAA ORGS
    public static LancasterFairfieldCAA = 'Lancaster-Fairfield Community Action Agency';
    public static OhioUniversityOrgName = 'OHIO University';

    // constant for resource file
    public static CAA = 'caa';
    public static Apportis = 'apportis';
    public static Ohio = 'ohio-university';

    public static OrgSpecificResource = 'OrgSpecificResource';
    public static ByAge = 'By Age';
    public static ByCounty = 'By County';
    public static ByBoth = 'By Age and County';
    public static University = 'University';
    public static Both = 'Both';
    public static Family = 'Family';
    public static Submenu = 'Submenu';
    public static StateOhio = 'Ohio';

    // Appointment Tabs Name
    public static Past = 'Past';
    public static Cancelled = 'Cancelled';
    public static Scheduled = 'Scheduled';
    public static Busy = 'Busy';

    // Browser names
    public static chrome = 'chrome';
    public static firefox = 'firefox';

    public static School = 'School';
    public static ErrorFile = 'ErrorFile';

    // Inactive and active tabs
    public static Active = 'Active';
    public static Deleted = 'Deleted';
    public static Inactive = 'Inactive';

    // Title
    public static ApportisTitle = ' | Apportis';

    // Multiple Clinician Values
    public static Multiple = 'Multiple';
    public static One = 'One';
    /// Encrypt and Decrypt key
    public static EncodeKey = 'Apportis2021';
    // Referral
    public static Myself = 'Myself';
    public static InvalidUserName = 'invalidUserName';
    public static ValidUserName = 'validUserName';
    public static VerifyUserName = 'verifyUserName';
    // Phone Codes
    public static SouthAfricaPhoneCode = '+27';

    // ReferralTypes
    public static ReferralGradePKto3IssueCategory = 'PreK-3';
    public static ReferralType = 'Referral';
    public static ReferralGrade6to8IssueCategory = '6-8';
    public static ReferralGrade4to5IssueCategory = '4-5';
    public static TuffBagReferralType = 'Tuff Bag';
    public static ReferralGrade9to11IssueCategory = '9and11';
    public static ReferralGrade10to12IssueCategory = '10and12';


    // public static BrandyReferraltype = 'PreK-3';
    // public static ReferralType = 'Referral';
    // public static SusanReferralType = '6-8';
    // public static KaylahReferralType = '4-5';
    // public static TuffBagReferralType = 'Tuff Bag';
    // public static CarrySmithReferralType = '9&11';
    // public static KristineTrimmerReferralType = '10&12';

    public static AssignedReferal = 'AssignedReferal';





}
